import React, { Component } from 'react';
import WaitForState from '../../../WaitForState';
import { getConversations } from '../../../../utility/conversation';
import { withUser } from '../../../../utility/withUser';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { addMessage } from '../../../../actions/messages';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/da';

/**
 * Component for showing conversation list.
 *
 * @extends React.Component
 */
class ConversationList extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      conversations: null,
    }
  }

  /**
   * Fetch the conversation list.
   */
  fetchConversations = () => {
    window.clearTimeout(this.updateTimeout);
    if (!this.props.filter) {
        return;
    }
    getConversations(this.props.filter, 0, 1000, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af samtaler. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var items = data.items || [];
        this.setState({conversations: items});
      });

      // Update conversation list every 10 seconds.
      window.clearTimeout(this.updateTimeout);
      this.updateTimeout = window.setTimeout(() => {
        this.fetchConversations();
      }, 10000);
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchConversations();
  }
  /** @inheritdoc */
  componentDidUpdate = () => {
    if (this.state.conversations === null) {
      this.fetchConversations();
    }
  }
  /** @inheritdoc */
  componentWillReceiveProps = () => {
    this.setState({conversations: null});
  }
  /** @inheritdoc */
  componentWillUnmount = () => {
    window.clearTimeout(this.updateTimeout);
  }

  /** @inheritdoc */
  render() {
    moment.locale('da');
    return (
      <div className="col-sm-12 col-md-3">
        <div className="widget">
          { this.props.filter === 'open' && <h3 className="section-heading">Åbne samtaler</h3>}
          { this.props.filter === 'mine' && <h3 className="section-heading">Mine samtaler</h3>}
          { this.props.filter === 'ongoing' && <h3 className="section-heading">Igangværende samtaler</h3>}
          { this.props.filter === 'archived' && <h3 className="section-heading">Arkiv</h3>}
          <div className="list-group" id="list-tab" role="tablist">
            <WaitForState state={this.state}>
              { this.state.conversations && (
                <div>
                  { this.state.conversations.length === 0 ? <span>Ingen samtaler</span> : this.state.conversations.map((conversation) => {
                    var gender = conversation.gender === 'male' ? 'Dreng' : conversation.gender === 'female' ? 'Pige' : 'Ukendt';
                    var loc = '/conversations/' + conversation.id;
                    var age = conversation.age ? conversation.age + ' år' : '';
                    var classes = "list-group-item list-group-item-action";
                    if (conversation.user_wait_from) {
                        if (moment().unix() - moment(conversation.user_wait_from).unix() > 5 * 60) {
                          classes += ' text-danger';
                        } else if (moment().unix() - moment(conversation.user_wait_from).unix() > 10) {
                          classes += ' text-warning';
                        }
                    }
                    return <Link key={conversation.id} className={classes} to={loc}><span className="badge badge-primary badge-pill">{conversation.message_count}</span> {gender} {age} {conversation.user_wait_from && <span>(Ventet {moment(conversation.user_wait_from).fromNow(true)})</span>
                    }</Link>
                  })}
                </div>
              )}
            </WaitForState>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(ConversationList)));



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/components/ConversationList/index.js